import { type RootState } from '../../../rmsReduxStore/rmsStore'

export default function getAcCustomerReducer (state: RootState): AcCustomerState   {
  return state.accustomersReducer
}
